import styled from 'styled-components';

export const StyledMachineRobotPowerInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${(props): string => props.theme.kcc.spacing.XXS};

  .machine-robot-power__wrapper {
    display: flex;
    align-items: center;
    gap: ${(props): string => props.theme.kcc.spacing.XXS};

    .machine-robot-power__icon {
      display: inline-flex;
      align-items: center;

      svg {
        display: block;
        width: 24px;
        height: 24px;
      }
    }

    .machine-robot-power__data {
      display: flex;
      align-items: center;

      // Odometer's digit-scroll animation crops to a fixed-height row using its own
      // font-size/line-height/height as one unit (see Odometer.styles.tsx) — line-height
      // and height must stay equal to font-size here, or the clip window cuts through glyphs.
      .odometer-wrapper {
        font-family: ${(props): string => props.theme.fonts.captionBold};
        font-weight: ${(props): number => props.theme.fontWeights.captionBold};
        color: ${(props): string => props.theme.colors.black};
        font-size: ${(props): number => props.theme.kcc.typography.FONT_SIZE.LG}px;
        line-height: ${(props): number => props.theme.kcc.typography.FONT_SIZE.LG}px;
        height: ${(props): number => props.theme.kcc.typography.FONT_SIZE.LG}px;
        word-break: break-word;
        white-space: normal;
      }

      // Line-height must match the odometer's above (not the 1.5 LINE_HEIGHT.LG multiplier),
      // otherwise this unit's own taller line box shifts it out of vertical alignment.
      .machine-robot-power__unit {
        font-family: ${(props): string => props.theme.fonts.captionBold};
        font-weight: ${(props): number => props.theme.fontWeights.captionBold};
        font-size: ${(props): number => props.theme.kcc.typography.FONT_SIZE.LG}px;
        line-height: ${(props): number => props.theme.kcc.typography.FONT_SIZE.LG}px;
        color: ${(props): string => props.theme.colors.black};
        margin: 0 4px;
      }
    }
  }

  .machine-robot-power__label {
    ${(props): string => props.theme.fontStyles.caption.news}
    color: ${(props): string => props.theme.kcc.colors.TEXT_SECONDARY};
    width: auto;
    word-break: break-word;
    white-space: normal;
  }
`;
